import { render, staticRenderFns } from "./MinhaConta.vue?vue&type=template&id=df8b388c&scoped=true"
import script from "./MinhaConta.vue?vue&type=script&lang=js"
export * from "./MinhaConta.vue?vue&type=script&lang=js"
import style0 from "./MinhaConta.vue?vue&type=style&index=0&id=df8b388c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8b388c",
  null
  
)

export default component.exports